import type { useTranslation } from "react-i18next";

import type { SupplierPaymentTerms } from "../../api/manufacturing";

type Translate = ReturnType<typeof useTranslation>["t"];

/** The name of a terms category, alone: "Net days", "Deposit + receipt". */
export function paymentTermsName(terms: SupplierPaymentTerms, t: Translate): string {
  switch (terms) {
    case "PAID_ON_ORDER":
      return t("payment-terms.on-order", "Paid on order");
    case "PAID_ON_RECEIPT":
      return t("payment-terms.on-receipt", "Paid on receipt");
    case "NET_DAYS":
      return t("payment-terms.net", "Net days");
    case "DEPOSIT":
      return t("payment-terms.deposit", "Deposit + receipt");
  }
}

/**
 * A supplier's terms as one short label: "On order", "On receipt", "Net 30",
 * "30 % + receipt". A net supplier without days shows the settings' days when
 * they are known, else "Net (default)".
 */
export function paymentTermsLabel(
  terms: SupplierPaymentTerms | null | undefined,
  days: number | null | undefined,
  depositPercent: number | null | undefined,
  t: Translate,
  defaultDays?: number | null,
): string {
  switch (terms) {
    case "PAID_ON_ORDER":
      return t("payment-terms.short.on-order", "On order");
    case "PAID_ON_RECEIPT":
      return t("payment-terms.short.on-receipt", "On receipt");
    case "DEPOSIT":
      return t("payment-terms.short.deposit", "{{percent}} % + receipt", { percent: depositPercent ?? 0 });
    case "NET_DAYS": {
      const value = days ?? defaultDays;
      return value == null ? t("payment-terms.short.net-default", "Net (default)") : t("payment-terms.short.net", "Net {{days}}", { days: value });
    }
    default:
      return "";
  }
}
